// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3Cec3","error":"Textarea_error__1t3vq","readonly":"Textarea_readonly__2USIQ","disabled":"Textarea_disabled__ROECs"};